'use client';

import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { isBot } from '@/utils/isBot';

interface PolicyInfoDaysAgoProps {
  fallbackDate: string;
  id: number;
}

export const PolicyInfoDaysAgo = ({
  fallbackDate,
  id,
}: PolicyInfoDaysAgoProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const feedback = useQuery({
    staleTime: 0,
    ...(isLogin
      ? AuthQueryOptions[
          'get:/wello/v2/auth/contents/feedback/{bestContentsId}'
        ]
      : UnauthQueryOptions[
          'get:/wello/v2/allows/contents/best/feedback/{bestContentsId}'
        ])({
      path: {
        bestContentsId: id,
      },
    }),
    select: (data) => data?.context?.daysAgo,
    enabled: isLogin !== undefined && !isBot(),
  });

  const daysAgo = feedback.data ?? fallbackDate;

  return (
    <time className="text-Gray-700 typo-caption1" dateTime={fallbackDate}>
      {daysAgo}
    </time>
  );
};
